import CameraController from "./camera_controller"
import RadiantMP from './rmp.min.mjs';

// Connects to data-controller="cctv--radiant-mp-camera"
export default class extends CameraController {
  static values = {
    name: String, url: String, id: String, type: String, replyUrl: String, exportButton: String
  }

  connect() {
  }


  async playArchive(event) {
    let camerasContainer = document.querySelector('#cameras_container');
    if (this.container && camerasContainer.contains(this.container)) {
      camerasContainer.removeChild(this.container);
      this.clear()
    }
    if (this.element.checked) {
      let data = {}
      document.dispatchEvent(new CustomEvent("archive:play", {
        bubbles: true, detail: {callback: (state) => data = state}
      }))
      const params = this.buildURLSearchParams(this.idValue, data['min'], data['max'])
      this.urlValue = `${this.urlValue}?${params.toString()}`;
      await this.toggleCamera();
      this.infoElement.style.display = 'none';
      this.playerElement.style.display = 'block';
    }

  }


  async buildCameraBlock(camerasContainer) {
    this.container = document.createElement("div");
    this.containerBuild(this.container, this.idValue)

    let wrapper = document.createElement('div');

    this.playerElement = document.createElement("div");
    this.playerBuild(this.playerElement, this.idValue)
    this.infoElement = document.createElement("div");

    this.headerElement = document.createElement("div");
    this.headerBuild(this.headerElement, this.nameValue)

    if (this.typeValue === 'archive') {

      let export_block = document.createElement("div");
      let link = document.createElement("a");
      this.linkBuild(link)

      let data = {}
      document.dispatchEvent(new CustomEvent("archive:play", {
        bubbles: true, detail: {callback: (state) => data = state}
      }))

      const params = this.buildURLSearchParams(this.idValue, data['min'], data['max'])

      this.linkExportBuild(link, params)
      export_block.appendChild(link);
      this.headerElement.appendChild(export_block)

    } else if (this.typeValue === 'live') {
      this.appendReplyBlock(this.headerElement, this.replyUrlValue)
    }

    this.container.appendChild(this.headerElement);
    this.container.appendChild(this.infoElement);
    this.container.appendChild(wrapper);

    wrapper.appendChild(this.playerElement);
    camerasContainer.appendChild(this.container);

    this.player = new RadiantMP('player_' + this.idValue.trim());
    await this.player.init(this.initRmp(this.urlValue));
  }

  pause() {
    if (this.element.checked) {
      this.player.pause()
    }
  }

  play() {
    if (this.element.checked) {
      this.player.play()
    }
  }

  disconnect() {
    super.disconnect()
  }


}